import { apiCall } from '@/util/apiCall'
import type {
	ConfigSearch,
	ConfigSearchEntryJson,
	ConfigSearchFilter,
	ConfigSearchFilterJson,
} from '@common/types/config/Search'
import { setConfigSearch } from '../config'
import { makeLoader } from './load'

export function cleanFilter(
	filter: ConfigSearchFilterJson,
): ConfigSearchFilter {
	return Object.fromEntries(
		Object.entries(filter).map(([k, v]) => [
			k,
			typeof v === 'string' ? [v] : v,
		]),
	)
}

export const loadConfigSearch = makeLoader({
	id: 'config-search',
	loader: async api => {
		const searchJson = await apiCall<ConfigSearchEntryJson>(
			'/valkyrie/config/config-search',
			{
				signal: api.signal,
				cache: 'preload-if-ssr',
			},
		)
		const search: ConfigSearch = {
			defs: searchJson.defs.map(entry => ({
				filter: cleanFilter(entry.filter),
				def: entry.def,
			})),
			results: {
				count: searchJson.results.count,
				order: searchJson.results.order.map(entry => ({
					filter: cleanFilter(entry.filter),
				})),
			},
			targets: searchJson.targets.map(entry => ({
				filter: cleanFilter(entry.filter),
				target: entry.target,
			})),
		}

		return setConfigSearch(search)
	},
})
